import { render, staticRenderFns } from "./GiftcardDetails.vue?vue&type=template&id=7a9118a5"
import script from "./GiftcardDetails.vue?vue&type=script&lang=js"
export * from "./GiftcardDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports